import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from './services/navigation.service';
import { ShopService } from './services/shop.service';
import { Order } from './models/order.model';
import { Page } from './models/page.model';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2/gst';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';

declare var ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'ngx-nooba-shop';
  activeCols$: any;
  activeCols = null;
  order$: any;
  order: Order = null;

  col0$: any;
  col0 = null;
  col1$: any;
  col1 = null;
  col2$: any;
  col2 = null;


  constructor(
    translate: TranslateService,
    private nav: NavigationService,
    private shop: ShopService,
    private cdr: ChangeDetectorRef,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private angulartics: Angulartics2GoogleGlobalSiteTag,
    private router: Router,
    private titleService: Title
  ) {
    this.angulartics.startTracking();

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

    this.matIconRegistry.addSvgIcon(
      'user',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/user.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'menu',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/menu.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'close',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/close.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'shopping-cart-white',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/shopping-cart-white.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'shopping-cart-black',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/shopping-cart-black.svg')
    );
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      console.log('FIRE:::', event, this.titleService.getTitle());
      if (event instanceof NavigationStart) {
        (window as any).gtag('config', 'UA-142147031-1', {
          page_path: event.url,
          page_title: this.titleService.getTitle()
        });
      }
    });
    this.shop.getPages().subscribe(
      (p: Array<Page>) => {
        this.shop.pages.next(p);
      }
    );
  }

  ngAfterViewInit() {
    this.col0$ = this.nav.col0.subscribe(c => {
      this.col0 = c;
      this.cdr.detectChanges();
    });
    this.col1$ = this.nav.col1.subscribe(c => {
      this.col1 = c;
      this.cdr.detectChanges();
    });
    this.col2$ = this.nav.col2.subscribe(c => {
      this.col2 = c;
      this.cdr.detectChanges();
    });
    this.order$ = this.shop.order.subscribe((o) => {
      this.order = o;
      this.cdr.detectChanges();
    });
  }

  isMobile() {
    return window.innerWidth < 1150;
  }
}
